import React, { useState, useEffect } from 'react';
import EditButton from '../EditButton/EditButton';
import { CardContent, Typography, Grid, Box, Drawer, Divider, Button, Modal } from '@mui/material';
import CardData from "../CardData/CardData";
import { IAccountLegalInformation } from "../../utils/account.types";
import {
  useAppSelector,
  useAppDispatch,
} from "../../store/hooks";
import { fetchStates } from '../../store/stateStore/stateThunk';
import DialogLegalForm from '../DialogLegalForm/DialogLegalForm';
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';

export default function LegalInformation() {

  const [open, setOpen] = useState(false);
  // const [fetchData, setFetchData] = useState('');

  const dispatch = useAppDispatch();
  const accountDetails = useAppSelector(state => state.account.accountDetails);
  // States list (id -> name) so we can show the State Of Reg. name instead of the stored id.
  const countryStates = useAppSelector(state => state.countryState.countryStates);

  const [legalInfo, setLegalInfo] = useState<IAccountLegalInformation>();
  const cardClicked = () => {
    setOpen(true);
  }

  const getData = (data: any): IAccountLegalInformation => {
    const {
      legalName,
      registrationNo,
      smeRegistrationFlag,
      stateOfRegistration,
      countryOfRegistration,
      taxIdentificationNumber1,
      taxIdentificationNumber2,
      companyType

    } = data;
    // stateOfRegistration is stored as a State id (string). Map it to the state name for display;
    // fall back to a populated object's name, then to the raw value if the list isn't loaded yet.
    const resolveStateName = (sr: any): string => {
      if (!sr) return '';
      if (typeof sr === 'object') return sr.name || '';
      const match = (countryStates || []).find((s: any) => s._id === sr);
      return match ? match.name : sr;
    };
    return {
      legalN: { value: legalName, title: 'Legal Name' },
      registration: { value: registrationNo, title: 'Registration#' },
      country: { value: countryOfRegistration?.name, title: "Country Of Reg." },
      state: { value: resolveStateName(stateOfRegistration), title: 'State Of Reg.' },
      tax1: { value: taxIdentificationNumber1, title: 'Tax Indentification #1' },
      tax2: { value: taxIdentificationNumber2, title: 'Tax Indentification #2' },
      companyT: { value: companyType, title: 'Company Type' },
      smeFlag: { value: smeRegistrationFlag ? 'Yes' : 'No', title: "SME Registration" },
    }
  };

  // Ensure the states list is available so we can show the state name (not the id).
  useEffect(() => {
    if (!countryStates || !countryStates.length) {
      dispatch(fetchStates());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let legalInfoAvaliable = true;

    const fetchLegalInfo = () => {
      try {
        if (legalInfoAvaliable) {
          Object.keys(accountDetails).length && setLegalInfo(getData(accountDetails));
        }
      } catch (error: any) {
        console.log('Registration and Legal information catch block called')
      }
    };
    fetchLegalInfo();
    return () => {
      legalInfoAvaliable = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountDetails, countryStates]);
  const legalData = () => {
    const data = [];
    for (const key in legalInfo) {
      data.push(<CardData key={key} card={legalInfo[key as keyof IAccountLegalInformation]} />)
    }
    return data;
  }

  const closeDialog = (isSaved: boolean) => {
    setOpen(false);

    // if (isSaved) {
    //   setFetchData(Math.random().toString());
    // }
  }

  return (
    <div className={'c-card2'} style={{ padding: 12, paddingTop: 12 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, m: '-12px -12px 12px', px: '12px', py: 0.5, bgcolor: '#e9ecf1', borderBottom: '1px solid #dcdcdc', borderRadius: '8px 8px 0 0' }}>
        <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, margin: 0 }}>Registration &#38; Legal</h5>
        <EditButton size='small' onClick={cardClicked} />
      </Box>
      <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{legalInfo?.companyT.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.companyT.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{legalInfo?.country.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.country.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{legalInfo?.state.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.state.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{legalInfo?.legalN.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.legalN.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{legalInfo?.registration.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.registration.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{legalInfo?.smeFlag.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.smeFlag.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{legalInfo?.tax1.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.tax1.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{legalInfo?.tax2.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>{legalInfo?.tax2.value || '-'}</h5>

      <Modal
            open={open}
            onClose={(event : any, reason:any) => {
                if (reason !== 'backdropClick') {
                    setOpen(true)
                }
            }}
        >
        {<DialogLegalForm open={open} data={accountDetails} onClose={closeDialog}></DialogLegalForm>}
      </Modal>
    </div>
  );
};
